import type { RoomSection } from "@secret-cabinet/contracts";
import { BookOpen, Landmark, QrCode, ScrollText, UsersRound } from "lucide-react";

const items: Array<{
  id: RoomSection;
  label: string;
  icon: typeof Landmark;
}> = [
  { id: "chamber", label: "Chamber", icon: Landmark },
  { id: "players", label: "Players", icon: UsersRound },
  { id: "record", label: "Record", icon: ScrollText },
  { id: "qr", label: "QR", icon: QrCode },
  { id: "rules", label: "Rules", icon: BookOpen },
];

export function RoomNav({ active, onChange }: { active: RoomSection; onChange: (section: RoomSection) => void }) {
  return (
    <nav className="room-nav" aria-label="Room sections">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <button
            type="button"
            key={item.id}
            className={active === item.id ? "is-active" : ""}
            aria-current={active === item.id ? "page" : undefined}
            onClick={() => onChange(item.id)}
          >
            <Icon aria-hidden="true" />
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
